import React from "react"
import "./floatingContact.scss"
import qrCode from "../../misc/qrCode.jpg"
import { Grid } from '@mui/material/';
import { useTranslation } from 'react-i18next';
import SETTINGS from "../../utils/constants";
import '../../utils/common.scss'

const FloatingContact=()=>{
  const {t} = useTranslation()
  return(
    <div className="floatingContainer general-text" style={{color: SETTINGS.DEEP_COLOR}}>
      <Grid container direction="column" sx={{visibility: {xs: 'hidden', sm: 'visible'}, maxWidth: '200px'}}>
        <Grid item>
          {t('floatingContact.text1')}
        </Grid>
        <Grid item>
          {t('floatingContact.text2')}
        </Grid>
        <Grid item>
          <img src={qrCode} style={{maxWidth: '200px'}} alt="qrCode" />
        </Grid>
        <Grid item>
          {t('floatingContact.text3')}
        </Grid>
        <Grid item>
          {t('floatingContact.text4')}
        </Grid>
      </Grid>
    </div>
  )
}

export default FloatingContact